import charlesImage from '../../images/charleskimdentistry-63.jpg';

const people = [
    {
      name: 'Charles Kim',
      role: 'DMD',
      imageUrl: charlesImage,
      bio: "Dr. Charlie was born and raised in Washington and attended Charles Wright Academy. He decided to escape the rain and move down to California to earn his bachelors of science degree at University of California, San Diego. Dr. Charlie then went on to complete his doctor of dental medicine degree at Western University of Health Sciences in Pomona, CA. Dr. Charlie and his wife, Catherine, currently reside in Tacoma and are enjoying being new parents to daughter Charlotte.",
      linkedinUrl: '#',
    }
  ]
  
  export default function AboutUs() {
    return (
      <div className="bg-white" id="our-team">
        <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
          <div className="space-y-12">
            <h2 className="text-3xl font-bold tracking-normal sm:text-4xl sm:tracking-tight">Meet Dr. Charlie</h2>
  
            <ul className="space-y-12 lg:grid lg:grid-cols-1 lg:items-start lg:gap-x-8 lg:gap-y-12 lg:space-y-0">
              {people.map((person) => (
                <li key={person.name}>
                  <div className="space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                    <div className="h-0 aspect-w-3 aspect-h-4">
                      <img className="object-cover shadow-lg rounded-lg" src={person.imageUrl} alt="" />
                    </div>
                    <div className="sm:col-span-2">
                      <div className="space-y-4 mt-16 sm:mt-0">
                        <div className="text-lg leading-6 font-medium space-y-1">
                          <h3>{person.name}</h3>
                          <p className="text-indigo-600">{person.role}</p>
                        </div>
                        <div className="text-lg">
                          <p className="text-gray-500">{person.bio}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
  